import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';

export const BeforeValueText = styled(Typography)({
  padding: '4px',
  wordBreak: 'break-word' as any,
  hyphens: 'auto',
  background: '#fdd7d5',
  marginBottom: '4px',
});

export const AfterValueText = styled(Typography)({
  padding: '4px',
  wordBreak: 'break-word' as any,
  hyphens: 'auto',
  background: '#c8ffd8',
  marginTop: '4px',
});
